import { As, Box, Text } from "@chakra-ui/react";
import { FC } from "react";
import { Group } from "../../types/Group";
import dayjs from "dayjs";

interface NavSyncWarningProps {
  groups: Group[];
}

const NavSyncWarning: FC<NavSyncWarningProps> = ({ groups }) => {
  // Filter groups that need syncing (less than or equal to 2 days remaining)
  const groupsNeedingSync = groups.filter((group) => {
    if (!group.lastSync) return false;
    const toEndDate = dayjs(group.lastSync.toEndDate);
    const today = dayjs();
    const daysUntilEnd = toEndDate.diff(today, "day");
    return daysUntilEnd <= 2;
  });

  if (groupsNeedingSync.length === 0) return null;

  return (
    <Box
      as={"marquee" as unknown as As}
      width="300px"
      height="30px"
      bg="red.500"
      borderRadius="md"
      display="flex"
      alignItems="center"
      direction="right"
      scrollamount="3"
      mr={4}
    >
      <Text color="white" fontWeight="bold" px={2}>
        ⚠️ ATTENTION! {groupsNeedingSync.length} group
        {groupsNeedingSync.length > 1 ? "s" : ""} need
        {groupsNeedingSync.length === 1 ? "s" : ""} sync update!
      </Text>
    </Box>
  );
};

export default NavSyncWarning;
